<template>
    <div id="orderForm" class="flex flex-wrap relative">
        <template v-if="!productInfo.product_id">
            <alert-box class="w-full">
                <template #body>
                    The product does not exist or access denied
                </template>
            </alert-box>
        </template>
        <template v-else>
            <div v-show="loading" class="absolute z-50 w-full h-full bg-spinner flex flex-col-reverse items-center">
                <spinner class="pb-1"></spinner>
            </div>

            <input v-model="formOrder.productid" type="hidden" />
            <input v-model="formOrder.billtermid" type="hidden" />
            <input v-model="formOrder.order_id" type="hidden" />
            <input v-model="formOrder.customer_id" type="hidden" />

            <div id="orderFormSummary" class="w-full bg-tan-200 border border-tan-500 p-6 md:mb-0 mb-8" :class="{'': formSubmitted, 'md:w-1/3': !formSubmitted}">
                <div class="flex flex-wrap">
                    <div class="w-full text-xs leading-normal" v-html="productInfo.description"></div>
                </div>
                <div class="w-full xs:hidden" v-if="!formSubmitted">
                    <div class="subsection flex flex-wrap">
                        <div class="inline-block subsection-title"><span class="fas fa-file-invoice-dollar mr-2"></span>Summary Information</div>
                    </div>
                    <div class="flex flex-wrap">
                        <div class="w-full mb-2 pb-2 border-b flex flex-wrap">
                            <div class="w-full">
                                <!-- <strong class="text-base">{{ billterm.metadata.title }} - {{ toCurrency(billterm.price) }}</strong> -->
                                <strong class="text-lg">{{ billterm.metadata.title }}</strong>
                                <p class="text-gray-700" v-html="billterm.metadata.description"></p>
                                <p class="text-gray-600" v-html="billterm.metadata.terms"></p>
                                <p class="text-gray-500 text-xs italic" v-html="billterm.metadata.shipping"></p>
                            </div>
                            <!-- <div class="w-full my-1" v-for="(billterm, index) in billTerms" :key="index">
                                <span class="mr-1" :class="{'hidden': billTerms.length <= 1}">
                                    <input type="radio" name="selectedBillTerm" :value="billterm" v-model="selectedBillTerm" :id="'option-' + index" />
                                </span>
                                <label :for="'option-' + index" class="cursor-pointer">
                                    <strong class="text-base">{{ getProductTerm(billterm) }}</strong>
                                    <p class="text-gray-700" v-if="billterm.metadata && billterm.metadata.description" v-html="billterm.metadata.description"></p>
                                    <p class="text-gray-600" v-if="billterm.metadata && billterm.metadata.terms" v-html="billterm.metadata.terms"></p>
                                    <p class="text-gray-500 text-xs italic" v-if="billterm.metadata && billterm.metadata.shipping" v-html="billterm.metadata.shipping"></p>
                                </label>
                            </div> -->
                        </div>
                        <div class="w-1/2 mb-1">
                            <p class="font-bold text-base mr-2">Subtotal</p>
                        </div>
                        <div class="w-1/2 mb-1 text-right">
                            <p class="text-base">{{ toCurrency(subTotal) }}</p>
                        </div>
                        <div class="w-1/2 mb-1">
                            <p class="font-bold text-base mr-2">Shipping</p>
                        </div>
                        <div class="w-1/2 mb-1 text-right">
                            <p class="text-base">{{ toCurrency(shippingCost) }}</p>
                        </div>
                        <div class="w-1/2 mb-1">
                            <p class="font-bold text-base mr-2">Taxes</p>
                        </div>
                        <div class="w-1/2 mb-1 text-right">
                            <p class="text-base">{{ toCurrency(taxAmount) }}</p>
                        </div>
                        <div class="w-1/2 mb-1">
                            <p class="font-bold text-base mr-2">Total</p>
                        </div>
                        <div class="w-1/2 mb-1 text-right">
                            <p class="text-base">{{ toCurrency(orderTotal) }}</p>
                        </div>
                        <!-- <div class="flex mt-4" v-if="!formSubmitted">
                            <label for="termsArgeed" class="italic">
                                <input v-model="formOrder.termsArgeed" id="termsArgeed" type="checkbox" true-value="yes" false-value="no" class="mr-1 mb-1" />
                                By checking this box I agree that I have read and agree to the <a href="/terms-of-service" target="_blank">Terms of Service</a> and <a href="/terms-of-service#privacy-policy" target="_blank">Privacy Policy</a>.
                                <span v-if="productInfo.agreed_notes" v-html="productInfo.agreed_notes"></span>
                                You can cancel at anytime by contacting support@commoditytrends.com or by phone at 541-955-2885.
                            </label>
                        </div>
                        <div class="w-full mt-6" v-if="!formSubmitted">
                            <div class="flex justify-center">
                                <button class="btn btn-lg btn-yellow inline-flex mx-1 text-l" @click="submitOrder" :disabled="formOrder.termsArgeed == 'no'">YES - Sign me Up!</button>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div v-if="formSubmitted" class="w-full mt-4">
                    <div class="text-blue-500">
                        <h2>Your form has been submitted. You're on your way to becoming a more successful trader.</h2>
                        <p>We want you to remember that you always have access to a dedicated staff of Course Counselors who are there to mentor you as you learn and perfect your skills. From daily and weekly video lessons and emails, to commodity quotes and charts, you'll feel part of our family of traders.</p>
                        <div class="mt-6">
                            <a :href="redirectUrl" class="btn btn-blue">PLEASE CLICK HERE TO CONTINUE...</a>
                        </div>
                        <img height="1" width="1" style="display:none" :src="metaSubmittedSrc" />
                        <img height="1" width="1" style="display:none" :src="emailPixelSubmittedSrc" />
                    </div>
                </div>
            </div>

            <div class="w-full md:w-2/3 py-2 px-0 md:px-8 md:mb-0 mb-8" v-if="!formSubmitted">
                <div id="errorsInformation" v-if="hasErrors">
                    <div class="alert alert-danger mb-0">
                        <p class="font-bold mb-2">The given data was invalid. Please correct the data in the highlighted fields.</p>
                        <ul class="mx-0">
                            <li v-for="(error, key) in errors" :key="key" v-html="error[0]"></li>
                        </ul>
                    </div>
                </div>
                <div id="contactInfo" class="mb-8">
                    <div class="subsection flex flex-wrap">
                        <div class="inline-block subsection-title"><span class="far fa-user-circle mr-2"></span>Account Information</div>
                    </div>
                    <div class="flex flex-wrap mb-2 mt-4">
                        <div class="w-full md:w-1/2 px-3 pb-4">
                            <label class="form-label-class" for="email">Email Address<sup>*</sup></label>
                            <div class="w-full flex justify-center">
                                <input v-model="formOrder.email" class="form-input" id="email" type="email" placeholder="Enter your email address" :class="{'is-invalid': errors && errors.email}" :disabled="isEmptyObject(customerInfo)" autocomplete="off" />
                            </div>
                        </div>
                        <div class="w-full md:w-1/2 px-3 pb-4">
                            <label class="form-label-class" for="baphone">Phone Number<sup>*</sup></label>
                            <input v-model="formOrder.baphone" class="form-input" id="baphone" type="tel" placeholder="Enter phone number" :class="{'is-invalid': errors && errors.baphone}" autocomplete="off" />
                        </div>
                        <div class="w-full md:w-1/2 px-3 pb-4" v-if="!isEmptyObject(customerInfo) || adminForm">
                            <label class="form-label-class" for="password">Password<sup>*</sup></label>
                            <input v-model="formOrder.password" class="form-input" id="password" type="password" placeholder="Enter your password" :class="{'is-invalid': errors && errors.password}" autocomplete="off" />
                        </div>
                        <div class="w-full md:w-1/2 px-3 pb-4" v-if="!isEmptyObject(customerInfo) || adminForm">
                            <label class="form-label-class" for="password_confirmation">Confirm Password<sup>*</sup></label>
                            <input v-model="formOrder.password_confirmation" class="form-input" id="password_confirmation" type="password" placeholder="Confirm your password" :class="{'is-invalid': errors && errors.password}" autocomplete="off" />
                        </div>
                        <div class="w-full md:w-1/2 px-3 pb-4">
                            <label class="form-label-class" for="first-name">First Name<sup>*</sup></label>
                            <input v-model="formOrder.fname" class="form-input" id="first-name" type="text" placeholder="Enter your first name" :class="{'is-invalid': errors && errors.fname}" autocomplete="off" />
                        </div>
                        <div class="w-full md:w-1/2 px-3 pb-4">
                            <label class="form-label-class" for="last-name">Last Name<sup>*</sup></label>
                            <input v-model="formOrder.lname" class="form-input" id="last-name" type="text" placeholder="Enter your last name" :class="{'is-invalid': errors && errors.lname}" autocomplete="off" />
                        </div>
                    </div>
                </div>

                <div id="billingAddress" class="mb-8">
                    <div class="subsection flex flex-wrap xs:pb-1 pb-0">
                        <div class="subsection-title mr-2"><span class="far fa-id-card mr-2"></span>Billing Address</div>
                        <span class="inline-block self-center xs:ml-0 ml-auto text-xs">
                            <label for="hideshipping">
                                <input v-model="formOrder.hideshipping" id="hideshipping" type="checkbox" true-value="yes" false-value="no" class="mr-1" />
                                Use billing address as Mailing/Postal address
                            </label>
                        </span>
                    </div>

                    <div class="w-full">
                        <div class="flex flex-wrap mb-2 mt-4">
                            <div class="w-full px-3 pb-4">
                                <label class="form-label-class" for="baaddress">Street Address<sup>*</sup></label>
                                <input v-model="formOrder.baaddress" class="form-input" id="baaddress" type="text" placeholder="Enter your street address" :class="{'is-invalid': errors && errors.baaddress}" autocomplete="off" />
                            </div>
                            <div class="w-full md:w-1/2 px-3 pb-4">
                                <label class="form-label-class" for="baaddress2">Apartment, Suite, etc.</label>
                                <input v-model="formOrder.baaddress2" class="form-input" id="baaddress2" type="text" placeholder="(Optional) Enter your apartment, suite, etc." :class="{'is-invalid': errors && errors.baaddress2}" autocomplete="off" />
                            </div>
                            <div class="w-full md:w-1/2 px-3 pb-4">
                                <label class="form-label-class" for="bacountry">Country<sup>*</sup></label>
                                <select @change="formOrder.bastate=''" v-model="formOrder.bacountry" class="form-control form-control-no-shadow" id="bacountry" :class="{'is-invalid': errors && errors.bacountry}" autocomplete="off">
                                    <option :value="country.code" v-for="(country, key) in countries" :key="key">{{ country.name }}</option>
                                </select>
                            </div>
                            <div class="w-full md:w-1/2 px-3 pb-4">
                                <label class="form-label-class" for="bacity">City<sup>*</sup></label>
                                <input v-model="formOrder.bacity" class="form-input" id="bacity" type="text" placeholder="Enter your city" :class="{'is-invalid': errors && errors.bacity}" autocomplete="off" />
                            </div>
                            <div class="w-full md:w-1/2 px-3 pb-4">
                                <div class="flex flex-wrap">
                                    <div v-if="states[formOrder.bacountry]" class="w-2/3 pr-3">
                                        <label class="form-label-class -mt-px" for="bastate">State<sup>*</sup></label>
                                        <select v-model="formOrder.bastate" class="form-control form-control-no-shadow" id="bastate" :class="{'is-invalid': errors && errors.bastate}" autocomplete="off">
                                            <option value="">Select State</option>
                                            <option :value="code" v-for="(state, code) in states[formOrder.bacountry]" :key="code">{{ state }}</option>
                                        </select>
                                    </div>
                                    <div class="w-1/3">
                                        <label class="form-label-class -mt-px" for="bazip">ZIP&nbsp;Code<sup>*</sup></label>
                                        <input v-model="formOrder.bazip" class="form-input" id="bazip" type="text" placeholder="ZIP code" :class="{'is-invalid': errors && errors.bazip}" autocomplete="off" />
                                    </div>
                                </div>
                                <div class="w-full mt-2" v-if="saleTaxAmount > 0">
                                    <div class="text-sm italic text-blue-500">Additional state sales tax charges of ${{saleTaxAmount}} will be applied to your order.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="shippingAddress" class="mb-8" v-if="formOrder.hideshipping == 'no'">
                    <div class="subsection flex flex-wrap">
                        <div class="inline-block subsection-title"><span class="fas fa-shipping-fast mr-2"></span>Mailing/Postal Address</div>
                    </div>

                    <div class="w-full">
                        <div class="flex flex-wrap mb-2 mt-4">
                            <div class="w-full px-3 pb-4">
                                <label class="form-label-class" for="saaddress">Street Address<sup>*</sup></label>
                                <input v-model="formOrder.saaddress" class="form-input" id="saaddress" type="text" placeholder="Enter your street address" :class="{'is-invalid': errors && errors.saaddress}" autocomplete="off" />
                            </div>
                            <div class="w-full md:w-1/2 px-3 pb-4">
                                <label class="form-label-class" for="saaddress2">Apartment, Suite, etc.</label>
                                <input v-model="formOrder.saaddress2" class="form-input" id="saaddress2" type="text" placeholder="(Optional) Enter your spartment, suite, etc." :class="{'is-invalid': errors && errors.saaddress2}" autocomplete="off" />
                            </div>
                            <div class="w-full md:w-1/2 px-3 pb-4">
                                <label class="form-label-class" for="sacountry">Country<sup>*</sup></label>
                                <select @change="formOrder.sastate=''" v-model="formOrder.sacountry" class="form-control form-control-no-shadow" id="sacountry" :class="{'is-invalid': errors && errors.sacountry}" autocomplete="off">
                                    <option :value="country.code" v-for="(country, key) in countries" :key="key">{{ country.name }}</option>
                                </select>
                            </div>
                            <div class="w-full md:w-1/2 px-3 pb-4">
                                <label class="form-label-class" for="sacity">City<sup>*</sup></label>
                                <input v-model="formOrder.sacity" class="form-input" id="sacity" type="text" placeholder="Enter your city" :class="{'is-invalid': errors && errors.sacity}" autocomplete="off" />
                            </div>
                            <div class="w-full md:w-1/2 px-3 pb-4">
                                <div class="flex flex-wrap">
                                    <div v-if="states[formOrder.sacountry]" class="w-2/3 pr-3">
                                        <label class="form-label-class -mt-px" for="sastate">State<sup>*</sup></label>
                                        <select v-model="formOrder.sastate" class="form-control form-control-no-shadow" id="sastate" :class="{'is-invalid': errors && errors.sastate}" autocomplete="off">
                                            <option value="">Select State</option>
                                            <option :value="code" v-for="(state, code) in states[formOrder.sacountry]" :key="code">{{ state }}</option>
                                        </select>
                                    </div>
                                    <div class="w-1/3">
                                        <label class="form-label-class -mt-px" for="sazip">ZIP&nbsp;Code<sup>*</sup></label>
                                        <input v-model="formOrder.sazip" class="form-input" id="sazip" type="text" placeholder="ZIP code" :class="{'is-invalid': errors && errors.sazip}" autocomplete="off" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="promoInfo" class="mb-8" v-if="formOrder.salessource || adminForm">
                    <div class="subsection flex flex-wrap">
                        <div class="inline-block subsection-title"><span class="fas fa-barcode mr-2"></span>Promotional Information</div>
                    </div>
                    <div class="flex flex-wrap mb-2 mt-4">
                        <div class="w-full px-3 pb-4">
                            <label class="form-label-class" for="source">Promo Code</label>
                            <input v-model="formOrder.source" class="form-input" id="source" type="text" placeholder="Enter promo/source code for the order" :class="{'is-invalid': errors && errors.source}" autocomplete="off" />
                        </div>
                    </div>
                    <div v-if="adminForm" class="flex flex-wrap mb-2 mt-4">
                        <div class="w-full px-3">
                            <label class="form-label-class" for="source">Sales Source</label>
                            <select v-model="formOrder.salessource" class="form-control form-control-no-shadow" name="source" id="source">
                                <option :value="null">None</option>
                                <option value="d-glover">Daven</option>
                                <option value="j-perry">Justin</option>
                                <option value="s-winn">Sandi</option>
                                <option value="t-heap">Travis</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div v-if="productInfo.showCreditCard" id="creditcardInfo" class="mb-8">
                    <div class="subsection flex flex-wrap">
                        <div class="inline-block subsection-title"><span class="far fa-credit-card mr-2"></span>Payment Information</div>
                    </div>
                    <div class="flex flex-wrap mb-2 mt-4">
                        <div class="w-full md:w-1/2 px-3 pb-4">
                            <label class="form-label-class" for="ccname">Name on Card<sup>*</sup></label>
                            <input v-model="formOrder.ccname" class="form-input" id="ccname" type="text" placeholder="Full Name" :class="{'is-invalid': errors && errors.ccname}" autocomplete="off" />
                        </div>
                        <div class="w-full md:w-1/2 px-3 pb-4">
                            <div class="flex flex-wrap">
                                <div class="w-2/3 pr-3 -mt-px">
                                    <label class="form-label-class -mt-px" for="cctype">Card Type<sup>*</sup></label>
                                    <select v-model="formOrder.cctype" class="form-control form-control-no-shadow" id="cctype" :class="{'is-invalid': errors && errors.cctype}" autocomplete="off">
                                        <option value="">Select Card Type</option>
                                        <option value="VISA">VISA</option>
                                        <option value="MC">Mastercard</option>
                                        <option value="AMEX">American Express</option>
                                        <option value="DSC">Discover</option>
                                    </select>
                                </div>
                                <div class="w-1/3 -mt-px">
                                    <label class="form-label-class -mt-px" for="ccvercode">CID&nbsp;Code<sup>*</sup></label>
                                    <input v-model="formOrder.ccvercode" @input="validateCIDCode" class="form-input" id="ccvercode" type="text" maxlength="4" placeholder="CID Code" :class="{'is-invalid': errors && errors.ccvercode}" autocomplete="off" />
                                </div>
                            </div>
                        </div>
                        <div class="w-full md:w-1/2 px-3 pb-4">
                            <label class="form-label-class" for="ccnum">Card Number<sup>*</sup></label>
                            <input v-model="formOrder.ccnum" @input="enforceNumeric" class="form-input" id="ccnum" type="text" maxlength="24" placeholder="Enter the card number" :class="{'is-invalid': errors && errors.ccnum}" autocomplete="off" />
                        </div>
                        <div class="w-full md:w-1/2 px-3">
                            <div class="flex flex-wrap">
                                <div class="w-2/3 pr-3">
                                    <label class="form-label-class -mt-px" for="ccexp">Expiration Month<sup>*</sup></label>
                                    <select v-model="formOrder.ccexpmonth" class="form-control form-control-no-shadow" id="ccexp" :class="{'is-invalid': errors && errors.ccexpmonth}" autocomplete="off">
                                        <option value="">Month</option>
                                        <option v-for="(month, key) in ccexpmonths" :key="key" :value="month">{{ getFullMonth(month) }}</option>
                                    </select>
                                </div>
                                <div class="w-1/3">
                                    <label class="form-label-class -mt-px" for="ccexpyear">Year<sup>*</sup></label>
                                    <select v-model="formOrder.ccexpyear" class="form-control form-control-no-shadow" id="ccexpyear" :class="{'is-invalid': errors && errors.ccexpyear}" autocomplete="off">
                                        <option value="">Year</option>
                                        <option v-for="(year, key) in ccexpyears" :value="`${year.slice(-2)}`" :key="key">{{year}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="errorsInformation" v-if="hasErrors">
                    <div class="alert alert-danger mb-8">
                        <p class="font-bold mb-2">The given data was invalid. Please correct the data in the highlighted fields.</p>
                        <ul class="mx-0">
                            <li v-for="(error, key) in errors" :key="key" v-html="error[0]"></li>
                        </ul>
                    </div>
                </div>

                <div id="summaryInformation" class="mb-8">
                    <div class="subsection flex flex-wrap">
                        <div class="inline-block subsection-title"><span class="fas fa-shipping-fast mr-2"></span>Summary Information</div>
                    </div>

                    <div class="w-full px-3">
                        <div class="flex flex-wrap">
                            <div class="w-1/2 mb-1">
                                <p class="font-bold text-base mr-2">Subtotal</p>
                            </div>
                            <div class="w-1/2 mb-1 text-right">
                                <p class="text-base">{{ toCurrency(subTotal) }}</p>
                            </div>
                            <div class="w-1/2 mb-1">
                                <p class="font-bold text-base mr-2">Shipping</p>
                            </div>
                            <div class="w-1/2 mb-1 text-right">
                                <p class="text-base">{{ toCurrency(shippingCost) }}</p>
                            </div>
                            <div class="w-1/2 mb-1">
                                <p class="font-bold text-base mr-2">Taxes</p>
                            </div>
                            <div class="w-1/2 mb-1 text-right">
                                <p class="text-base">{{ toCurrency(taxAmount) }}</p>
                            </div>
                            <div class="w-1/2 mb-1">
                                <p class="font-bold text-base mr-2">Total</p>
                            </div>
                            <div class="w-1/2 mb-1 text-right">
                                <p class="text-base">{{ toCurrency(orderTotal) }}</p>
                            </div>
                            <div class="flex mt-4">
                                <div id="captcha"></div>
                            </div>
                            <div class="flex flex-wrap mt-4">
                                <label for="termsArgeed" class="text-base w-full mb-4">
                                    <input v-model="formOrder.termsArgeed" id="termsArgeed" type="checkbox" true-value="yes" false-value="no" class="mr-1 mb-1" />
                                    I agree to the <a href="/terms-of-service" target="_blank"><b>Terms of Service</b></a> and <a href="/terms-of-service#privacy-policy" target="_blank"><b>Privacy Policy</b></a>.
                                </label>
                                <label for="termsArgeedTrial" class="text-base w-full" v-if="['USC_SEASON24_PD', 'USC_SEASON25_PD', 'USC_SEASON26_PD'].includes(formOrder.productid)">
                                    <input v-model="formOrder.termsArgeedTrial" id="termsArgeedTrial" type="checkbox" true-value="yes" false-value="no" class="mr-2 mb-1">
                                    <span v-if="productInfo.agreed_notes" v-html="productInfo.agreed_notes" class="agreed_notes_span"></span>
                                </label>
                                <label for="termsArgeedTrial" class="text-base w-full" v-else>
                                    <input v-model="formOrder.termsArgeedTrial" id="termsArgeedTrial" type="checkbox" true-value="yes" false-value="no" class="mr-2 mb-1" />
                                    <span v-if="productInfo.agreed_notes" v-html="productInfo.agreed_notes" class="agreed_notes_span"></span>
                                </label>
                            </div>
                            <div class="w-full mt-6">
                                <div class="flex justify-center">
                                    <!-- <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="cancelOrder" v-if="cancelRoute">Cancel</div> -->
                                    <button class="btn btn-lg btn-yellow inline-flex mx-1 text-l" @click="submitOrder" :disabled="formOrder.termsArgeed == 'no' || formOrder.termsArgeedTrial == 'no'">YES - Sign me Up!</button>
                                </div>
                                <div class="mt-8 w-full border p-4" v-show="['USC_SEASON24_PD', 'USC_SEASON25_PD', 'USC_SEASON26_PD'].includes(formOrder.productid)">
                                    <div class="text-sm">WARNING: FUTURES AND OPTIONS trading involves high risks and YOU can LOSE a lot of money. You should carefully study commodity trading and consider whether such trading is suitable for you in light of your circumstances and financial resources before you trade. Seasonal increases (or decreases) in the demand for commodities do not necessarily result in an increase (or decrease) in the value of the option or futures contract on those commodities because the market has already factored the seasonal demand into the price of the futures or option.</div>
                                </div>
                                <div class="mt-8 w-full border p-4" v-show="formOrder.productid == 'USC_BINARY_ONL'">
                                    <div class="text-sm">Trading on Nadex involves financial risk and may not be appropriate for all investors. The information presented here is for information and educational purposes only and should not be considered an offer or solicitation to buy or sell any financial instrument on Nadex or elsewhere. Any trading decisions that you make are solely your responsibility. Past performance is not necessarily indicative of future results. Nadex contracts are based on underlying asset classes including forex, stock index futures, commodity futures, cryptocurrencies, and economic events.</div>
                                    <div class="text-sm mt-4">Trading can be volatile and investors risk losing their investment on any given transaction. However, the design of Nadex contracts ensures investors cannot lose more than the cost to enter the transaction. Nadex is subject to U.S. regulatory oversight by the CFTC.</div>
                                </div>
                                <div class="mt-8 w-full border p-4" v-show="formOrder.productid == 'USC_CBMTP'">
                                    <div class="text-sm">WARNING: FUTURES AND OPTIONS trading involves high risks and YOU can LOSE a lot of money. The risk of loss in trading commodity futures and options contracts can be substantial. There is a high degree of leverage in futures trading because of the small margin requirements. This leverage can work against you as well as for you and can lead to large losses as well as large gains. No representation is being made that any account will or is likely to achieve profits or losses similar to those shown. In the event the account has losses, you may need to deposit additional funds to maintain margin or to initiate new positions as called for by the trading program. This brief statement cannot disclose all the risks and other significant aspects of the commodity markets. You should carefully study commodity trading and consider whether such trading is suitable for you in light of your circumstances and financial resources before you trade. Please know that the above services are not intended to nor shall they provide any commodity trading advice based on or tailored to your particular circumstances or characteristics such as any of your personal financial details, current investments or trading accounts. Past results are not necessarily indicative of Future Results.</div>
                                    <!-- <div class="text-sm mt-4"><a href="https://uscharts.s3.amazonaws.com/pdf/CTTP%20Trading%20Capsule.pdf" target="_blank">Click here</a> for a capsule performance of actual trading results.</div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <flash-message :secondsToDisplay="20" ref="flashRef"></flash-message>
    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue';

const props = defineProps({
    productInfo: {
        type: Object,
        required: true,
        default: () => ({}),
    },
    customerInfo: {
        type: Object,
        default: () => ({}),
    },
    adminForm: {
        type: Boolean,
        default: false,
    },
    cancelRoute: String,
    countries: Array,
    states: Object,
    source: String,
    salessource: String,
    useCaptcha: {
        type: Boolean,
        required: false,
        default: false,
    },
    siteKey: String,
});

const flashRef = ref(false);
const loading = ref(false);
const errors = ref({});

const formSubmitted = ref(false);

const redirectUrl = computed(() => props.productInfo.redirectUrl || '/home');
const metaSubmittedSrc = ref('');
const emailPixelSubmittedSrc = ref('');

const billterm = computed(() => props.productInfo.billterm);
const saleTaxAmount = ref(0);

const shipping = computed(() => props.productInfo.delivery.method);

const loggedIn = ref(window.currentUser && window.currentUser.username ? true : false);

const formOrder = ref({
    productid: props.productInfo.product_id,
    billtermid: props.productInfo.billterm.id,
    order_id: '',
    customer_id: '',
    delivery: null,
    source: props.source || null,
    salessource: props.salessource || null,

    email: props.customerInfo.email || null,
    password: null,
    password_confirmation: null,
    fname: props.customerInfo.fname || null,
    lname: props.customerInfo.lname || null,

    hideshipping: 'yes',
    freeProduct: props.productInfo.showCreditCard ? false : true,

    baaddress: props.customerInfo.saaddress || null,
    baaddress2: props.customerInfo.saaddress2 || null,
    bacity: props.customerInfo.sacity || null,
    bastate: props.customerInfo.sastate || '',
    bazip: props.customerInfo.sazip || null,
    bacountry: props.customerInfo.sacountry || 'USA',
    baphone: props.customerInfo.saphone || null,
    bacompany: null,

    saaddress: props.customerInfo.saaddress || null,
    saaddress2: props.customerInfo.saaddress2 || null,
    sacity: props.customerInfo.sacity || null,
    sastate: props.customerInfo.sastate || '',
    sazip: props.customerInfo.sazip || null,
    sacountry: props.customerInfo.sacountry || 'USA',
    saphone: props.customerInfo.saphone || null,
    sacompany: null,

    ccnum: null,
    ccname: null,
    ccvercode: null,
    cctype: '',
    ccexpmonth: '',
    ccexpyear: '',

    ccexp: '',
    captcha: false,
    termsArgeed: 'no',
    termsArgeedTrial: 'no',
    agreedNotes: '',
});

const timer = ref(null);

function enforceNumeric(event) {
    const value = event.target.value;
    const numericValue = value.replace(/[^0-9]/g, '');

    if (value !== numericValue) {
        event.target.value = numericValue;
        formOrder.value.ccnum = numericValue;
    }
}

const validateCIDCode = (event) => {
    // Update the model only with numeric input, preserving leading zeros
    formOrder.value.ccvercode = event.target.value.replace(/[^0-9]/g, '');
};

const setDelivery = (country) => {
    if (!shipping.value || shipping.value.id === 'ONL') {
        formOrder.value.delivery = 'ONL';
        return;
    }

    if (!['USA', 'CAN'].includes(country)) {
        country = 'INT';
    }

    const delivery = shipping.value.find(mShipping => mShipping.destinations === country);
    formOrder.value.delivery = delivery.id;
};

watch(() => formOrder.value.bacountry, (mCountry) => {
    setDelivery(mCountry);
}, { immediate: true });

watch(() => formOrder.value.sacountry, (mCountry) => {
    setDelivery(mCountry);
});

const shippingCost = computed(() => {
    if (!shipping.value || shipping.value.id === 'ONL') {
        return 0;
    }

    const addressType = formOrder.value.hideshipping === 'yes' ? 'ba' : 'sa';

    let country = formOrder.value[addressType + 'country'];

    if (!['USA', 'CAN'].includes(country)) {
        country = 'INT';
    }

    const delivery = shipping.value.find(mShipping => mShipping.destinations === country);

    return delivery ? Number(delivery.price) : 0;
});

const subTotal = computed(() => {
    getTaxAmount();
    return Number(billterm.value.price);
});

const taxAmount = computed(() => saleTaxAmount.value);

const orderTotal = computed(() => subTotal.value + shippingCost.value + saleTaxAmount.value);

const hasErrors = computed(() => Object.keys(errors.value).length > 1);

const ccexpmonths = [
    '01', '02', '03', '04',
    '05', '06', '07', '08',
    '09', '10', '11', '12'
];

const ccexpyears = computed(() => {
    const years = [];
    const currentYear = (new Date()).getFullYear();

    for (let i = 0; i < 18; i++) {
        years.push((currentYear + i).toString());
    }

    return years;
});

const getFullMonth = (value) => {
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June', 'July',
        'August', 'September', 'October', 'November', 'December',
    ];
    return value + ' - ' + months[parseInt(value) - 1];
};

const toCurrency = (value) => {
    if (typeof value !== 'number') {
        value = Number(value);
    }
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
    });
    return formatter.format(value);
};

const getTaxAmount = () => {
    if (props.productInfo.product_id && formOrder.value.bacity && formOrder.value.baaddress && formOrder.value.bastate && formOrder.value.bazip && billterm.value.price > 0) {
        const route = window.route('order.taxamount-order');
        const params = {
            productid: props.productInfo.product_id,
            price: billterm.value.price,
            shipping: shippingCost.value,
            address: formOrder.value.baaddress,
            city: formOrder.value.bacity,
            state: formOrder.value.bastate,
            zip: formOrder.value.bazip,
        };

        clearTimeout(timer.value);
        timer.value = setTimeout(() => {
            axios.post(route, params)
                .then((response) => {
                    if (response.data && response.data.success === true) {
                        saleTaxAmount.value = Number(response.data.tax_amount);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }, 700);
    } else {
        saleTaxAmount.value = 0.00;
    }
};

const isEmptyObject = (obj) => Object.keys(obj).length > 0;

const cancelOrder = () => {
    window.location.href = props.cancelRoute;
};

const submitOrder = () => {
    loading.value = true;
    errors.value = {};
    formOrder.value.saphone = formOrder.value.baphone;
    formOrder.value.orderName = props.productInfo.orderName;
    formOrder.value.ccexp = `${formOrder.value.ccexpmonth}${formOrder.value.ccexpyear}`;
    formOrder.value.agreedNotes = props.productInfo?.agreed_notes ? props.productInfo.agreed_notes.replace(/<\/?[^>]+(>|$)/g, "") : "N/A";

    if (props.productInfo.refCode && !formOrder.value.source) {
        formOrder.value.source = props.productInfo.refCode;
    }

    const route = loggedIn.value ? window.route('order.create-order') : window.route('order.anon.create-order');

    axios.post(route, formOrder.value)
        .then((response) => {
            loading.value = false;

            if (response.data && response.data.success === true) {
                if (response.data.order_id) {
                    formOrder.value.order_id = response.data.order_id;
                }

                if (response.data.customer_id) {
                    formOrder.value.customer_id = response.data.customer_id;
                }

                if (response.data.approved === false) {
                    flashRef.value.error(response.data.error_message || 'The order cannot be processed. Please try again later or reach out to us at support@commoditytrends.com for assistance.');
                    if (typeof grecaptcha !== 'undefined') {
                        grecaptcha.reset();
                    }
                } else {
                    metaSubmittedSrc.value = 'https://www.facebook.com/tr?id=429844965139253&ev=Subscribe&cd[currency]=USD&cd[predicted_ltv]=395.00&cd[value]=' + orderTotal.value;
                    emailPixelSubmittedSrc.value = 'https://www.google-analytics.com/collect?v=1&t=event&ec=email&ea=purchase&t=event&tid=G-SXPPW2KV3D&z=1663259577&cid=d22bc780-9f43-8e0e-d8e0-30b4445ff1b3&dt=Log%20In&dp=/login';
                    // gtag('event', 'conversion', { 'send_to': 'G-SXPPW2KV3D', 'value': orderTotal.value });
                    formSubmitted.value = true;
                    flashRef.value.display('Thanks for filling out our form! Your form has been successfully sent.');
                }
            } else {
                flashRef.value.error('The given data was invalid. Please correct the data in the highlighted fields.');
                if (typeof grecaptcha !== 'undefined') {
                    grecaptcha.reset();
                }
            }
        })
        .catch((error) => {
            loading.value = false;

            if (error.response) {
                if (error.response.data.errors) {
                    errors.value = error.response.data.errors;
                }

                if (error.response.status === 401) {
                    flashRef.value.error('Please complete the captcha');
                    if (typeof grecaptcha !== 'undefined') {
                        grecaptcha.reset();
                    }
                    return;
                }

                if (!error.response.data.error_message || error.response.data.error_message == '') {
                    flashRef.value.error('Something went wrong, please try again later.');
                    if (typeof grecaptcha !== 'undefined') {
                        grecaptcha.reset();
                    }
                    return;
                }

                let flashMessage = error.response.data.error_message;

                if (flashMessage === 'The given data was invalid.') {
                    flashMessage = 'The given data was invalid. Please correct the data in the highlighted fields.';
                } else if (/Undefined|Error processing transaction|loadXML/i.test(flashMessage)) {
                    flashMessage = 'Something went wrong. Please try again later or reach out to us at support@commoditytrends.com for assistance.';
                }

                flashRef.value.error(flashMessage);
            } else {
                flashRef.value.error('Something went wrong, please try again later.');
            }

            if (typeof grecaptcha !== 'undefined') {
                grecaptcha.reset();
            }
        });
};

const updateCaptcha = (response) => {
    formOrder.value.captcha = response;
};

onMounted(async () => {
    if (!loggedIn.value) {
        await ensureRecaptchaIsReady();
        grecaptcha.render('captcha', {
            sitekey: props.siteKey,
            callback: updateCaptcha,
        });
        getTaxAmount();
    }
});

function ensureRecaptchaIsReady() {
    return new Promise((resolve) => {
        if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
            resolve();
        } else {
            let checkRecaptchaReady = setInterval(() => {
                if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
                    clearInterval(checkRecaptchaReady);
                    resolve();
                }
            }, 100);
        }
    });
}
</script>

<style lang="scss">
#errorsInformation {
    @apply text-xs py-4;
    ul {
        @apply px-5;
    }
}

#orderForm {
    .agreed_notes_span {
        p {
            display: inline;
        }
    }
    #orderFormSummary {
        p {
            @apply mt-1;
        }
    }

    sup {
        @apply text-yellow-500;
    }

    label {
        font-weight: normal;
        @apply leading-normal;
    }

    .form-input,
    select.form-control {
        margin-bottom: 0 !important;
    }

    .error {
        margin-top: 0.5rem !important;
    }

    table {
        thead,
        tfoot {
            td, th {
                @apply px-3 py-2;
            }
        }
        thead {
            tr {
                @apply border-t;
                td, th {
                    @apply text-left;
                }
            }
        }
        tbody {
            td, th {
                @apply px-3 py-2 text-left;
            }
        }
    }
}
</style>
